"use client";

import React, { createContext, useContext, useState, ReactNode } from "react";

// Tipos de header que a aplicação pode ter
export type HeaderType = "default" | "embarcaAi" | "none";

// Interface do contexto
interface HeaderContextType {
  headerType: HeaderType;
  setHeaderType: (type: HeaderType) => void;
  // Flag para verificar se um header personalizado foi definido para a página atual
  hasCustomHeader: boolean;
  setHasCustomHeader: (value: boolean) => void;
}

// Criando o contexto com valores padrão
const HeaderContext = createContext<HeaderContextType>({
  headerType: "default",
  setHeaderType: () => {},
  hasCustomHeader: false,
  setHasCustomHeader: () => {},
});

// Hook para facilitar o uso do contexto em componentes
export const useHeader = () => useContext(HeaderContext);

// Provedor do contexto
export const HeaderProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [headerType, setHeaderType] = useState<HeaderType>("default");
  const [hasCustomHeader, setHasCustomHeader] = useState(false);

  return (
    <HeaderContext.Provider
      value={{
        headerType,
        setHeaderType,
        hasCustomHeader,
        setHasCustomHeader,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};

export default HeaderContext;
